import CheckoutHeader from "../components/CheckoutHeader";
import CheckoutBody from "../components/CheckoutBody";

export default function Checkout () {
    return(
        <>
            <CheckoutHeader/>
            <CheckoutBody/>
        </>
    )
}
